var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"pa-0",attrs:{"width":"100%","height":_vm.height,"color":"subBackgroundColor"}},[_c('v-list-item-group',{class:_vm.isPadding ? 'pa-2 pb-15' : ''},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }